// extracted by mini-css-extract-plugin
module.exports = {"holder":"GalleryPage_holder__3i_OW"};